import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class Footer extends Vue {
  @Getter getUniversity: any
  @State user: any
}
